export const CK_EDITOR_CONFIG = {
  clipboard_defaultContentType: 'html'
};
